import { render, staticRenderFns } from "./AssignAccessStudentList.vue?vue&type=template&id=3f3c9074&scoped=true"
import script from "./AssignAccessStudentList.vue?vue&type=script&lang=js"
export * from "./AssignAccessStudentList.vue?vue&type=script&lang=js"
import style0 from "./AssignAccessStudentList.vue?vue&type=style&index=0&id=3f3c9074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c9074",
  null
  
)

export default component.exports